import { Table } from "antd";
import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;
  overflow: auto;
`;

function StatisticTable({ data, loading, pagination, columns }) {
  /**
   * @type {React.MutableRefObject<import("antd").FormInstance>}
   */

  return (
    <Wrapper>
      <Table loading={loading} columns={columns} dataSource={data} pagination={pagination} id="card_number">
        IDTable
      </Table>
    </Wrapper>
  );
}

export default StatisticTable;
